import { ReactElement } from 'react';
import Sections from '~/components/layout/Sections';
import PerformableGroupForm, {
  PerformableGroupNested,
  usePerformableGroup,
} from '~/components/performable/PerformableGroupForm';
import { BreOrderContext } from '~/tenants/bre/model/BreOrderContext';
import BrePackageGroup from '~/tenants/bre/package/BrePackageGroup';
import { BrePackagePhotosInclude, BreZillowInclude } from '~/tenants/bre/package/common';
import BrePhotosCommunityAddOn from '~/tenants/bre/performable/photos/BrePhotosCommunityAddOn';
import BrePhotosConfig from '~/tenants/bre/performable/photos/BrePhotosConfig';
import BrePhotosFields from '~/tenants/bre/performable/photos/BrePhotosFields';
import BrePhotosLocalAreaAddOn from '~/tenants/bre/performable/photos/BrePhotosLocalAreaAddOn';
import BreZillowConfig from '~/tenants/bre/performable/zillow/BreZillowConfig';
import { PersonaType } from '~/tenants/common/TenantPersona';
import { TenantPackageIncludes } from '~/tenants/common/package';

export default function BreZillowPackageForm(): ReactElement {
  const { order } = usePerformableGroup<BreOrderContext>();

  return (
    <Sections>
      <TenantPackageIncludes>
        <PerformableGroupNested performable={BrePhotosConfig}>
          <BrePackagePhotosInclude />
        </PerformableGroupNested>
        <PerformableGroupForm performable={BreZillowConfig}>
          <BreZillowInclude />
        </PerformableGroupForm>
      </TenantPackageIncludes>

      <BrePackageGroup itemNum={1} subtitle="Customize the ground photography." performable={BrePhotosConfig}>
        <BrePhotosFields context={order} />
        <BrePhotosCommunityAddOn context={order} persona={PersonaType.CUSTOMER} />
        <BrePhotosLocalAreaAddOn context={order} persona={PersonaType.CUSTOMER} />
      </BrePackageGroup>
    </Sections>
  );
}
